export const RELATIONSHIP_FOCUS_MODES = [
    {
        id: 'relationship-tension',
        spread_slug: 'relationship-two-polarities',
        label: 'Relationship Tension',
        description: 'Porta in primo piano i punti dove il legame si tende e si consuma.',
        highlighted_positions: [3, 4],
        hidden_positions: [6],
        narrative_bias: 'relationship',
    },
    {
        id: 'relationship-repair',
        spread_slug: 'amore-dinamica-di-coppia',
        label: 'Relationship Repair',
        description: 'Evidenzia ferita, risorsa e possibilità di ricucitura del campo.',
        highlighted_positions: [4, 6, 7],
        narrative_bias: 'healing',
    },
    {
        id: 'relationship-polarity',
        spread_slug: 'nuova-connessione',
        label: 'Relationship Polarity',
        description: 'Accentua il gioco fra i due poli e il desiderio che li avvicina.',
        highlighted_positions: [1, 2, 3],
        narrative_bias: 'relationship',
    },
];
//# sourceMappingURL=relationship-focus.js.map